import { motion } from "framer-motion";
import { WhatsAppIcon } from "./Icons";
import { WHATSAPP_URL } from "../../lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Escribinos por WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.95 }}
    className="group fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full bg-[#25D366] p-4 text-white shadow-[0_14px_40px_-10px_rgba(37,211,102,.7)]"
  >
    <WhatsAppIcon className="h-6 w-6" />
    <span className="hidden max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width] duration-500 group-hover:max-w-[200px] md:inline">
      ¿Consultas? Escribinos
    </span>
  </motion.a>
);
